import React from 'react'
import { Video } from '@christies/react/components/Editorial'
import { RenderFields, videoSourceFormatter } from '../../utils'
import { VideoType } from '../../sharedTypes'
import { ImageValue, withParsedContext, SelectValue } from '../../withJSSContext'
import { Theme } from '@christies/react/foundations'

interface Props {
  parsedRouteFields: {
    'Story Theme': SelectValue<Theme | undefined>
  }
  parsedFields: {
    'Hide Video': boolean
    'Video Description'?: string
    'Video Type'?: SelectValue<'6' | '8' | '12'>
    'Video Image': ImageValue
    'Video Source': SelectValue<VideoType>
    'Brightcove Id'?: string
    'Youtube Id'?: string
    'Embedded Video'?: string
  }
  parsedSitecoreContext: {
    'Brightcove Account Id'?: string
    'Brightcove Video Url'?: string
    'Youtube Video Url'?: string
  }
}

const MagazinesInlineVideoModule: React.FC<Props> = ({ parsedFields, parsedRouteFields, parsedSitecoreContext }) => {
  const hideVideo = parsedFields?.['Hide Video']
  const imageUrl = parsedFields?.['Video Image']?.src
  const videoType = parsedFields?.['Video Source']?.key
  const videoUrl = videoSourceFormatter({
    videoType: videoType,
    brightcove: {
      videoUrl: parsedSitecoreContext?.['Brightcove Video Url'],
      accountId: parsedSitecoreContext?.['Brightcove Account Id'],
      videoId: parsedFields?.['Brightcove Id'],
    },
    youtube: {
      videoUrl: parsedSitecoreContext?.['Youtube Video Url'],
      videoId: parsedFields?.['Youtube Id'],
    },
    embedded: {
      videoUrl: parsedFields?.['Embedded Video'],
    },
  })

  if (hideVideo && !imageUrl) return null

  return (
    <RenderFields parsedFields={parsedFields}>
      <Video
        description={parsedFields?.['Video Description']}
        lgWidth={parsedFields?.['Video Type']?.key}
        imageUrl={imageUrl}
        videoUrl={hideVideo ? undefined : videoUrl}
        videoType={videoType}
        theme={parsedRouteFields?.['Story Theme']?.key}
      />
    </RenderFields>
  )
}

export default withParsedContext(MagazinesInlineVideoModule as React.FC)
